import { createSelector } from 'reselect'

import { fromVeniceSelector, canShareVeniceSelector } from './venice'

export const canShareSelector = createSelector(
  [fromVeniceSelector(), canShareVeniceSelector],
  (fromVenice, canShareVenice) => !fromVenice || canShareVenice
)
